<ion-icon name="add-circle" class="editor__icon text-4xl cursor-pointer" (click)="showSources($event)" [class.opacity-70]="buttonDisabled()"></ion-icon>

